export default __webpack_public_path__ + "static/media/simlogo.fcd6483a.svg";